import styled, { css } from 'styled-components';

// Prefix of each reward surface's --dcm-<prefix>-badge-* theming variables. New reward
// surfaces extend this union and the fallback map below — the pill builds the var names.
export type RewardBadgePrefix = 'cart-cash-back' | 'pbb-points-boost';

export const RewardBadgePill = styled.span.withConfig({ componentId: 'pbb-reward-badge-pill' })<{
  $prefix: RewardBadgePrefix;
}>`
  ${({ theme: { colors }, $prefix }) => css`
    background-color: var(--dcm-${$prefix}-badge-bg, ${colors.white});
    border-radius: var(--dcm-${$prefix}-badge-border-radius, 999px);
    color: var(--dcm-${$prefix}-badge-text-color, ${colors.black});
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    padding: 4px 8px;
  `}
`;
